<template>
  <span v-if="tamanhos !== null">
    <span :id="cpntHashId + '-span'" v-if="$store.state.mobile !== true" >
      <modal v-if="tela !== null" :id="cpntHashId" :name="cpntHashId" :class="cpntHashId" ref="modal" class="app-dialog-modal"
      :draggable="$store.state.mobile === false ? '.app-dialog-header' : false" 
      :width="cpntLargura"
      :height="'auto'"
      :scrollable="false"
      :reset="true"
      :clickToClose="cpntFundoFechar"
      @before-close="appDialogHide"
      :styles="'max-width: ' + (tela.width * 0.95) + 'px; max-height: ' + (tela.height * 0.95) + 'px;'"
      >
        <!-- APRESENTA A PAGINA -->
        <div class="app-dialog" ref='geral'>
          <header ref="header" class="app-dialog-header" v-show="cpntStatus !== 'carregando'" v-if="[ '', null, undefined ].indexOf(cpntTitulo) === -1 || Object.keys($slots).indexOf('titulo') !== -1 || Object.keys($slots).indexOf('botoes') !== -1">
            <table :class="cpntAbaVet !== null ? 'app-dialog-header-com-abas' : ''">
              <tr>
                <td>
                  <!-- SETA O TITULO VIA STRING -->
                  <template v-if='[ "", null, undefined ].indexOf(cpntTitulo) === -1 && typeof cpntTitulo === "string"'>
                    <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
                    <span v-html="cpntTitulo"></span>
                  </template>

                  <!-- SETA O SLOT DO TITULO -->
                  <slot v-if="Object.keys($slots).indexOf('titulo') !== -1" name="titulo"></slot>
                </td>

                <td class="fechar" v-if="Object.keys($slots).indexOf('botoes') !== -1 || butonFechar !== null" :style="Object.keys($slots).indexOf('botoes') !== -1 ? '' : 'width: 30px;'">
                  <table v-show="cpntOcultarBotoes !== true">
                    <tr>
                      <!-- SETA O CAMPO PARA ESPAÇAMENTO -->
                      <td class="espaco"></td>

                      <!-- SETA OS BOTOES ADICIONAIS NO TITULO -->
                      <td style="padding-right: 10px;" v-if="cpntStatus === '' && Object.keys($slots).indexOf('botoes') !== -1">
                        <slot name="botoes"></slot>
                      </td>

                      <!-- SETA O BOTÃO DE FECHAR -->
                      <td v-if="butonFechar !== null">
                        <RF-Button
                          :cpntId="butonFechar.id"
                          :cpntStatus='butonFechar.status' 
                          :cpntTipo='butonFechar.tipo'
                          :cpntClass='butonFechar.class'

                          @onClickButton='() => { butonFechar.onClick() }'
                        ></RF-Button>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>

              <tr v-if="Object.keys($slots).indexOf('complemento_titulo') !== -1">
                <td colspan="2" style="padding: 0px 10px 0px 10px;">
                  <slot name="complemento_titulo"></slot>
                </td>
              </tr>

              <tr v-if="cpntStatus !== 'carregando' && cpntAbaVet !== null">
                <td colspan="2" class="app-dialog-header-abas">
                  <RF-Aba v-if="cpntAbaVet !== null"
                    :cpntAbas="Object.values(cpntAbaVet)"
                    :cpntValue="cpntAbaValue"
                    :cpntOnChange="cpntAbaOnChange"
                    :cpntOnNewTab="cpntAbaNewTab"
                  ></RF-Aba>
                </td>
              </tr>
            </table>
          </header>

          <div ref="body" class="app-dialog-body">
            <div class="app-dialog-contant">
              <div :style="'width: calc(' + cpntLargura + ' - 30px)'" class="app-dialog-conteudo">
                <!-- SETA O STATUS -->
                <RF-Status v-if='cpntStatus !== ""' :cpntStatus='cpntStatus' :cpntTamanho='5' style="margin: 40px 0px;"></RF-Status>

                <!-- MOSTRA O CONTEUDO DA TELA -->
                <slot v-else name="conteudo"></slot>
              </div>
            </div>
          </div>

          <footer ref="footer" class="app-dialog-footer" v-show="cpntStatus === ''" v-if="Object.keys($slots).indexOf('rodape') !== -1 || Object.keys($slots).indexOf('rodape-left') !== -1 || Object.keys($slots).indexOf('rodape-right') !== -1">
            <table>
              <tr v-if="Object.keys($slots).indexOf('rodape-left') !== -1 || Object.keys($slots).indexOf('rodape-right') !== -1">
                <td>
                  <slot name="rodape-left"></slot>
                </td>
                <td>
                  <slot name="rodape-right"></slot>
                </td>
              </tr>

              <tr v-if="Object.keys($slots).indexOf('rodape') !== -1">
                <td colspan="2">
                  <slot name="rodape"></slot>
                </td>
              </tr>
            </table>
          </footer>
        </div>
      </modal>
    </span>

    <span :id="cpntHashId + '-span-2'" v-else class="app-dialog-mobile">
      <div>
        <div class="app-dialog" ref='geral'>
          <header ref="header" class="app-dialog-header" v-show="cpntStatus !== 'carregando'" v-if="[ '', null, undefined ].indexOf(cpntTitulo) === -1 || Object.keys($slots).indexOf('titulo') !== -1 || Object.keys($slots).indexOf('botoes') !== -1">
            <table :class="cpntAbaVet !== null ? 'app-dialog-header-com-abas' : ''">
              <tr>
                <td>
                  <!-- SETA O TITULO VIA STRING -->
                  <template v-if='[ "", null, undefined ].indexOf(cpntTitulo) === -1 && typeof cpntTitulo === "string"'>
                    <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
                    <span v-html="cpntTitulo"></span>
                  </template>

                  <!-- SETA O SLOT DO TITULO -->
                  <slot v-if="Object.keys($slots).indexOf('titulo') !== -1" name="titulo"></slot>
                </td>

                <td class="fechar" v-if="Object.keys($slots).indexOf('botoes') !== -1 || butonFechar !== null" :style="Object.keys($slots).indexOf('botoes') !== -1 ? '' : 'width: 30px;'">
                  <table v-show="cpntOcultarBotoes !== true">
                    <tr>
                      <!-- SETA O CAMPO PARA ESPAÇAMENTO -->
                      <td class="espaco"></td>

                      <!-- SETA OS BOTOES ADICIONAIS NO TITULO -->
                      <td style="padding-right: 10px;" v-if="cpntStatus === '' && Object.keys($slots).indexOf('botoes') !== -1">
                        <slot name="botoes"></slot>
                      </td>

                      <!-- SETA O BOTÃO DE FECHAR -->
                      <td v-if="butonFechar !== null">
                        <RF-Button
                          :cpntId="butonFechar.id"
                          :cpntStatus='butonFechar.status' 
                          :cpntTipo='butonFechar.tipo'
                          :cpntClass='butonFechar.class'

                          @onClickButton='() => { butonFechar.onClick() }'
                        ></RF-Button>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>

              <tr v-if="Object.keys($slots).indexOf('complemento_titulo') !== -1">
                <td colspan="2" style="padding: 0px 10px 0px 10px;">
                  <slot name="complemento_titulo"></slot>
                </td>
              </tr>

              <tr v-if="cpntStatus !== 'carregando' && cpntAbaVet !== null">
                <td colspan="2" class="app-dialog-header-abas">
                  <RF-Aba v-if="cpntAbaVet !== null"
                    :cpntAbas="Object.values(cpntAbaVet)"
                    :cpntValue="cpntAbaValue"
                    :cpntOnChange="cpntAbaOnChange"
                    :cpntOnNewTab="cpntAbaNewTab"
                  ></RF-Aba>
                </td>
              </tr>
            </table>
          </header>
          
          <div ref="body" class="app-dialog-body">
            <div ref="contant" class="app-dialog-contant">
              <div :style="'width: calc(' + cpntLargura + ' - 30px)'" class="app-dialog-conteudo">
                <!-- SETA O STATUS -->
                <RF-Status v-if='cpntStatus !== ""' :cpntStatus='cpntStatus' :cpntTamanho='5' style="margin: 40px 0px;"></RF-Status>

                <!-- MOSTRA O CONTEUDO DA TELA -->
                <slot v-else name="conteudo"></slot>
              </div>
            </div>
          </div>

          <footer ref="footer" class="app-dialog-footer" v-show="cpntStatus === ''" v-if="Object.keys($slots).indexOf('rodape') !== -1 || Object.keys($slots).indexOf('rodape-left') !== -1 || Object.keys($slots).indexOf('rodape-right') !== -1">
            <table>
              <tr v-if="Object.keys($slots).indexOf('rodape-left') !== -1 || Object.keys($slots).indexOf('rodape-right') !== -1">
                <td>
                  <slot name="rodape-left"></slot>
                </td>
                <td>
                  <slot name="rodape-right"></slot>
                </td>
              </tr>

              <tr v-if="Object.keys($slots).indexOf('rodape') !== -1">
                <td colspan="2">
                  <slot name="rodape"></slot>
                </td>
              </tr>
            </table>
          </footer>
        </div>
      </div>
    </span>
  </span>
</template>

<style scoped>
.app-dialog-mobile {
  /* position: relative; */
  /* position: static; */
}
  .app-dialog-mobile > div {
    background: #fff;
    z-index: 3500;
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100vw;
    max-width: 100vw;
    height: 100vh;
    max-height: 100vh;
  }
    .app-dialog-mobile > div > div {
      position: relative;
      /* height: 100vh; */

      height: 100%;
      display: flex;
      flex-direction: column;
    }
      .app-dialog-mobile > div > div > .app-dialog-header {
        /* position: absolute;
        top: 0px; */
        flex: 0 0 auto;
      }
      .app-dialog-mobile > div > div > .app-dialog-header > table > tr > td.fechar > table > tr > td:last-child {
        width: 36px;
        vertical-align: top;
      }

      .app-dialog-mobile > div > div > .app-dialog-body {
        position: absolute;
        /* top: 178px; */
        flex: 1 1 auto;
        vertical-align: middle;
        width: 100%;
      }
        /* .app-dialog-mobile > div > div > .app-dialog-body > div > div {
          width: 100% !important;
          height: 100% !important;
          overflow: auto !important;
        }
        .app-dialog-mobile > div > div > .app-dialog-body > div > .app-dialog-conteudo {
        } */

        .app-dialog-mobile > div > div > .app-dialog-body > .app-dialog-contant {
          padding: 10px 10px 20px 15px;
          overflow: auto;
          max-height: 100%;
          width: calc(100% + 5px);
          margin-left: -5px;
        }
        .app-dialog-mobile > div > div > .app-dialog-body > .app-dialog-contant > .app-dialog-conteudo {
          width: 100% !important;
        }
      .app-dialog-mobile > div > div > .app-dialog-footer {
        position: absolute;
        bottom: 0px;
        flex: 0 0 auto;
      }




.app-dialog-modal {
  z-index: 3500;
}

.app-dialog > div {
  border-radius: 10px;
}
.app-dialog {
  position: relative;
  /* max-height: 100vh; */
}

.app-dialog-header {
  width: 100%;
  background: #e9e9e9;
  font-weight: bold;
  text-align: left;
}
.app-dialog-header:not(.app-dialog-header-com-abas) {
  border-bottom: 1px solid #cacaca;
}
  .app-dialog-header > table {
    width: 100%;
  }
    .app-dialog-header > table > tr:first-child > td {
      padding: 10px 10px 5px 10px;
    }
    .app-dialog-header > table > tr > td.fechar {
      vertical-align: top;
      width: 1%;
      white-space: nowrap;
    }
      .app-dialog-header > table > tr > td.fechar > table {
        width: 100%;
        text-align: right;
      }
      .app-dialog-header > table > tr > td.fechar > table > tr > td:not(.espaco) {
        width: 1%;
        white-space: nowrap;
      }

    .app-dialog-header-com-abas > tr > td.app-dialog-header-abas {
      padding: 0px;
      border-bottom: none;
    }
      .app-dialog-header-com-abas > tr > td.app-dialog-header-abas > div {
        width: calc(100% - 1px);
        margin-bottom: -1px;
      }
.app-dialog-header {
  /* position: absolute; */
  position: relative;
  top: 0px;
}
.app-dialog-body > .app-dialog-contant {
  padding: 10px 10px 10px 15px;
  overflow: auto;
  max-height: 100%;
  width: calc(100% + 5px);
  margin-left: -5px;
}
.app-dialog-footer {
  /* position: absolute; */
  position: relative;
  bottom: 0px;

  width: 100%;
  background: #e9e9e9;
  border-top: 1px solid #cacaca;
  text-align: left;
  padding: 10px;
}
  .app-dialog-footer > table {
    width: 100%;
  }
</style>

<style>
  .app-dialog-header > table > tr:first-child > td > svg {
    margin-right: 3px;
  }
  .app-dialog-modal > .vm--modal {
    border-radius: 10px !important;
  }
  .app-dialog-header-com-abas > tr > td.app-dialog-header-abas > div > .tabs > div > ul > li:first-child {
    margin-left: 5px;
  }
  .app-dialog-body > .app-dialog-contant > .app-dialog-conteudo > .rf-status {
    height: 90px;
    margin: 0px !important;
  }

  /* .app-dialog-mobile > div > .vm--modal {
    max-height: 95% !important;
    margin: 0px auto;
  }
    .app-dialog-mobile > div > .vm--modal > .app-dialog {
      overflow: auto !important;
    }
      .app-dialog-mobile > div > .vm--modal > .app-dialog > .app-dialog-header,
      .app-dialog-mobile > div > .vm--modal > .app-dialog > .app-dialog-footer {
        position: relative !important;
      }
      .app-dialog-mobile > div > .vm--modal > .app-dialog > .app-dialog-body {
        padding-top: 0px !important;
      }
        .app-dialog-mobile > div > .vm--modal > .app-dialog > .app-dialog-body > .app-dialog-contant {
          max-height: initial !important;
          overflow-y: hidden !important;
        }
          .app-dialog-mobile > div > .vm--modal > .app-dialog > .app-dialog-body > .app-dialog-contant > .app-dialog-conteudo {
            margin-bottom: 0px !important;
          } */
</style>

<script>
  // IMPORTA A FUNÇÃO PARA ATUAIZAR OS DADOS DA API
  const FUN_ADD_REM_SCROOL_BODY = require('@/assets/js/Funcoes-Gerais.js').FUN_ADD_REM_SCROOL_BODY

  // INICIA O VUE
  export default {
    props: {
      cpntHashId: {
        required: false,
        type: String,
        default: function () {
          // INICIA A VARIAVEL ID
          var id = ''

          // INICIA PARA VERIFICAR SE ENCONTROU UM ID
          var flag = false

          while (flag === false) {
            // GERA UM ID PARA O CAMPO
            id = 'cpnt-dialog-' + (Math.floor(Math.random() * (9999 - 1000)) + 1000).toString()

            // VERIFICA SE O ID GERADO É UNICO NA TELA
            flag = [ '', null, undefined ].indexOf(document.getElementById(id)) !== -1
          }

          // RETONAR O VALOR MONTADO
          return id
        }
      },
      cpntStatus: {
        required: false,
        type: [ Object, String ],
        default: function () {
          return ''
        }
      },
      cpntFundoFechar: {
        required: false,
        type: Boolean,
        default: function () {
          return true
        }
      },
      cpntAnimacao: {
        required: false,
        type: Boolean,
        default: function () {
          return true
        }
      },
      cpntRegistro: {
        required: false,
        type: Array,
        default: function () {
          return []
        }
      },
      cpntLargura: {
        required: false,
        type: String,
        default: function () {
          return '530px'
        }
      },
      cpntTitulo: {
        required: false,
        default: function () {
          return ''
        }
      },
      cpntAlturaTipo: {
        required: false,
        default: function () {
          return ''
        }
      },
      cpntAlturaValor: {
        required: false,
        default: function () {
          return ''
        }
      },
      cpntButtonDireitaClick: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntButtonDireitaTitle: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntOcultarBotoes: {
        required: false,
        type: Boolean,
        default: function () {
          return false
        }
      },
      cpntStatusImprimir: {
        required: false,
        type: Boolean,
        default: function () {
          return false
        }
      },
      cpntKeyUp: {
        required: false,
        type: Array,
        default: function () {
          return []
        }
      },
      cpntAbaVet: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntAbaValue: {
        required: false,
        default: function () {
          return ''
        }
      },

      // FUNÇOES RECEBIDAS
      cpntAbaNewTab: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntAbaOnChange: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntOnKeyUp: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntOnFecharDialog: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    components: {
      'RF-Aba': () => import('@/components/rf-geral/aba/RF-Aba-2.vue')
    },
    data: function () {
      return {
        tela: null,
        tamanhoCall: null,
        butonFechar: {
          status: '',
          id: this.cpntHashId + '-span' + '--bt-fechar',
          tipo: 'fechar',
          class: [ 'btn', 'btn-danger' ],
          fechando: false,
          onClick: () => {
            // SETA O FLAG PARA FECHAR
            this.butonFechar.fechando = false
            
            // CHAMA A FUNÇÃO PARA FECHAR
            this.appDialogFechar(false)

            // VERIFICA SE DEVE MOSTRAR O SCROLL DA PAGINA
            setTimeout(() => { FUN_ADD_REM_SCROOL_BODY() }, 0)
          }
        },
        tamanhos: { header: 0, footer: 0, body: 0 }
      }
    },
    destroyed: function () {
      // DESTROY A DIALOG
      this.tela = null

      // VERIFICA SE DEVE HABILITAR OU NÃO O SCROLL DA PAGINA
      setTimeout(() => { FUN_ADD_REM_SCROOL_BODY() }, 0)

      // // REMOVE OS OBSERVADORES PARA ALTERAÇÃO DA POSIÇÃO DA DIALOG
      // document.removeEventListener('focus', this.appDialogCalcularTamanhoFocusBlur, true)
      // document.removeEventListener('blur', this.appDialogCalcularTamanhoFocusBlur, true)
    },
    mounted: function () {
      // // ADICIONA OS OBSERVADORES PARA ALTERAÇÃO DA POSIÇÃO DA DIALOG
      // document.addEventListener('focus', this.appDialogCalcularTamanhoFocusBlur, true)
      // document.addEventListener('blur', this.appDialogCalcularTamanhoFocusBlur, true)

      // INICIA O PROCESSO
      this.appDialogIniciar()
    },
    created: function () {
      if (this.$store.state.mobile === true) {
        this.tamanhoCall = setInterval(() => {
          // INICIA A VARIAVEL
          var tamH = 0
          var tamF = 0

          // VERIFICA SE AS INFORMAÇÕES EXISTE
          if ([ '', null, undefined ].indexOf(this.$refs) === -1) {
            // VERIFICA SE O TOPO EXISTE NA DIALOG
            if ([ '', null, undefined ].indexOf(this.$refs.header) === -1) {
              tamH = this.$refs.header.offsetHeight
            }
            
            // VERIFICA SE O RODAPE EXISTE NA DIALOG
            if ([ '', null, undefined ].indexOf(this.$refs.footer) === -1) {
              tamF = this.$refs.footer.offsetHeight
            }

            // VERIFICA SE EXISTE O MEIO
            if ([ '', null, undefined ].indexOf(this.$refs.body) === -1) {
              this.$refs.body.style.top = tamH + 'px'


              // this.$refs.contant.style.height = 'calc(100% - ' + tamH + 'px - ' + (tamF * 2) + 'px)'
              this.$refs.contant.style.height = (window.innerHeight - tamH - tamF)
              
              if (tamF > 0) {
                this.$refs.footer.style.bottom = tamF + 'px'
              }
            }
          }          
        }, 1000)
      }
    },
    beforeDestroy: function () {
      clearInterval(this.tamanhoCall)
    },
    methods: {
      appDialogIniciar: function () {
        // SETA O TAMANHO DA TELA RECEBIDO
        this.tela = { height: Number(window.innerHeight), width: Number(window.innerWidth) }

        // CHAMA A FUNÇÃO PARA ABRIR A JANELA
        setTimeout(() => {
          // MANDA ABRIR A DIALOG
          this.$modal.show(this.cpntHashId)

          // VERIFICA SE DEVE HABILITAR OU NÃO O SCROLL DA PAGINA
          setTimeout(() => { FUN_ADD_REM_SCROOL_BODY() }, 0)

          // CHAMA A FUNÇÃO PARA CALCULAR OS TAMANHOS
          this.appDialogCalcularTamanhoDialog()
        }, 100)
      },
      appDialogHide: function () {
        // LIMPA O VALOR DA VARIAVEL
        this.tamanhos = null

        // CHAMA A FUNÇÃO PARA FECHAR
        this.appDialogFechar(false, null, {})

        // VERIFICA SE DEVE HABILITAR OU NÃO O SCROLL DA PAGINA
        setTimeout(() => { FUN_ADD_REM_SCROOL_BODY() }, 0)
      },
      appDialogFechar: function (atualizar, id, dados) {
        // LIMPA O VALOR DA VARIAVEL
        this.tamanhos = null
        
        // VERIFICA A AÇÃO DO CAMPO
        if (this.butonFechar.fechando === false) {
          // SETA O FLAG QUE JÁ ESTÁ FECHANDO A TELA
          this.butonFechar.fechando = true
          
          // LIMPA O VALOR DA VARIAVEL
          this.tamanhos = null
  
          // CHAMA A FUNÇÃO PARA FECHAR A TELA
          this.cpntOnFecharDialog(atualizar, id, dados)
        }

        // VERIFICA SE DEVE HABILITAR OU NÃO O SCROLL DA PAGINA
        setTimeout(() => { FUN_ADD_REM_SCROOL_BODY() }, 0)
      },
      // appDialogCalcularTamanhoFocusBlur: function (event) {
      //   if ([ 'input', 'INPUT', 'textarea', 'TEXTAREA' ].indexOf(event.target.tagName) !== -1) {
      //     this.appDialogCalcularTamanhoDialog()
      //   }
      // },
      appDialogCalcularTamanhoDialog: function (tentativa = 0) {
        if (this.tela !== null && tentativa <= 1000) {
          // PEGA A DIALOG  
          var modal = document.getElementById(this.cpntHashId)
          
          // VERIFICA SE FOI ENCONTRADO ALGUMA DIALOG
          if ([ '', null, undefined ].indexOf(modal) === -1) {
            // PEGA A JANELA QUE FOI ABERTA
            modal = modal.querySelector('.vm--modal')

            // VERIFICA SE FOI ENCONTRADO ALGUMA JANELA
            if ([ '', null, undefined ].indexOf(modal) === -1) {
              // CORRIGI O LEFT SE ESTIVER ERRADO
              this.appDialogCorrigirPosicaoNegativa(modal)

              // CHAMA A FUNÇÃO PARA CALCULARA A ALTURA PARA BARRA DE ROLAGEM
              this.appDialogCalcularHeightDialog(modal)

              // REINICIA ESTE PROCESSO
              setTimeout(() => { this.appDialogCalcularTamanhoDialog(0) }, 1000)
            } else {
              setTimeout(() => { this.appDialogCalcularTamanhoDialog((tentativa + 1)) }, 1)
            }
          } else {
            setTimeout(() => { this.appDialogCalcularTamanhoDialog((tentativa + 1)) }, 1)
          }
        }
      },
      appDialogCorrigirPosicaoNegativa: function (modal) {
        // PEGA A POSIÇÃO LEFT DO MODAL
        var left = modal.style.left

        // REMOVE OS PARAMETROS PARA FICAR APENAS NUMERO
        left = left.replace('px', '')
        left = left.replace('%', '')

        // CONVERTE O VALOR EM NUMERO
        left = Number(left)

        // VERIFICA SE TEM QUE ALTERAR O VALOR DO CAMPO
        if ([ '', null, undefined ].indexOf(left) === -1 && left < 0) {
          modal.style.left = '0px'
        }

        // PEGA A POSIÇÃO LEFT DO MODAL
        var top = modal.style.top

        // REMOVE OS PARAMETROS PARA FICAR APENAS NUMERO
        top = top.replace('px', '')
        top = top.replace('%', '')

        // CONVERTE O VALOR EM NUMERO
        top = Number(top)

        // VERIFICA SE TEM QUE ALTERAR O VALOR DO CAMPO
        if ([ '', null, undefined ].indexOf(top) === -1 && top < 0) {
          modal.style.top = '0px'
        }
      },
      appDialogCalcularHeightDialog: function (modal) {        
        // VERIFICA A AÇÃO QUE DEVE REALIZAR
        switch (this.$store.state.mobile) {
          case true:
            // PEGA A DIALOG
            var dialog = modal.querySelector('.app-dialog')

            // SETA O TAMANHO MAXIMO DA TELA
            dialog.style.maxHeight = 'calc(' + modal.style.maxHeight.toString() + ')'
            break

          default:
            // PEGA AS DIV PARA CALCULAR
            var titulo = modal.querySelector('.app-dialog-header')
            var contant = modal.querySelector('.app-dialog-contant')
            var rodape = modal.querySelector('.app-dialog-footer')

            // PEGA OS TAMANHOS DOS CAMPOS
            var alturaT = [ '', null, undefined ].indexOf(titulo) === -1 && titulo.style.display !== 'none' ? titulo.offsetHeight : 0
            var alturaR = [ '', null, undefined ].indexOf(rodape) === -1 && rodape.style.display !== 'none' ? rodape.offsetHeight : 0

            // SETA A MARGIN TOP
            contant.style.maxHeight = 'calc(' + modal.style.maxHeight.toString() + ' - ' + (alturaT + alturaR).toString() + 'px)'
            break
        }

      }
    }
  }
</script>
